
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockApproveSetAssembleDialog extends Serenity.EntityDialog<IcStockApproveSetAssembleRow, any> {
        protected getFormKey() { return IcStockApproveSetAssembleForm.formKey; }
        protected getIdProperty() { return IcStockApproveSetAssembleRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveSetAssembleRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveSetAssembleRow.nameProperty; }
        protected getService() { return IcStockApproveSetAssembleService.baseUrl; }
        protected getDeletePermission() { return IcStockApproveSetAssembleRow.deletePermission; }
        protected getInsertPermission() { return IcStockApproveSetAssembleRow.insertPermission; }
        protected getUpdatePermission() { return IcStockApproveSetAssembleRow.updatePermission; }

        protected form = new IcStockApproveSetAssembleForm(this.idPrefix);

        constructor() {
            super();
            this.form = new IcStockApproveSetAssembleForm(this.idPrefix);
            (this.form.IcStockApproveSetAssembleDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });




        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =  /// เอาไว้ใช้ขา Approve
                {
                    title: "อนุมัติ",
                    hint: "Approve and create Adjust Doc.",
                    separator: false,
                    cssClass: "button-Approve-post",
                    icon: "fa fa-save",
                    //hotkey: 'alt+shift+s',
                    onClick: (e) => {

                        var self = this;
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                        Q.confirm('ยืนยันการอนุมัติเอกสาร' + "\r\n" +
                            'เมื่ออนุมัติ ระบบจะทำการ สร้างเอกสาร ปรับปรุงเพิ่มและลดโดยอัตโนมัติ และสั่ง POST'
                            , () => {
                                this.form.ApproveFg.value = "1";

                                this.form.PostFg.value = "3";
                                // this.form.PostFg.forceUpdate();
                                // if (this.validateForm() && this.validateBeforeSave()) {
                                    var options = this.getSaveOptions((respons2) => {

                                        if (this.isEditMode()) {
                                            var id1 = respons2.EntityId;
                                            if (id1 == null) {
                                                id1 = this.get_entityId();
                                            }
                                            this.loadById(id1);
                                        }
                                        else {
                                            this.loadById(respons2.EntityId);
                                            // this.dialogClose();
                                        }

                                        this.showSaveSuccessMessage(respons2);


                                    });

                                    options.onError = function (respons2) {
                                        Q.alert(respons2.Error.Message);



                                    }

                                    Q.serviceCall(options);
                                // }
                                // this.showSaveSuccessMessage(respons2);



                            });

                        });

                        options.onError = function (response) {
                            Q.alert(response.Error.Message);

                        }

                        Q.serviceCall(options);
                    }







                    }
                }; buttons.push(newSavePosBtn);



                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            //this.form.IcStockApproveSetAssembleDtList.myPassValue = this.entity.SysDocNo




            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            // self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        // if (self.element.parent().find(".panel-titlebar").length == 1) {
                        //     // self.element.parent().find(".panel-titlebar").html("");
                        //     // self.element.parent().find(".panel-titlebar-text").html("");
                        //     self.element.parent().find(".panel-titlebar-close").html("");
                        // }
                        // else {
                        //     changeTitle();
                        // }
                    }
                }, 100);
            })();
            if (this.entity.PostFg > 0  || this.entity.CancelFg == 1) {
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-Approve-post').hide();
                this.toolbar.findButton('button-save').hide();
                this.deleteButton.toggleClass('disabled', true);
                this.form.IcStockApproveSetAssembleDtList.set_readOnly(true);
            } else {


            }
        }


        // protected getSaveEntity(): IcStockApproveSetAssembleRow {
        //     let entity = super.getSaveEntity();

        //     return entity;
        // }



    }
}